import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { ACCOUNT_SEARCH_URL } from "../ApiUrls";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class AccountSearchRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  url = ACCOUNT_SEARCH_URL;

  body = {
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: null,
    sin: "",
    pan: "",
    memberId: "",
    mobileNumber: "",
    homeNumber: "",
    email: "",
    address: "",
    city: "",
    province: "",
    postalCode: "",
    country: "",
    bankingType: "PERSONAL",
    page: 0,
    size: 20,
  };

  constructor(searchCriteria) {
    super();
    this.body = {
      ...this.body,
      ...searchCriteria,
    };
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
